export default __webpack_public_path__ + "locales/vi/EmbeddingPanel.json?hash=4c890ed1cd0ad8b1c73440d847df3c94";